import React from 'react';
import type { LuggageType } from 'src/components/Luggage/types';

import styled from 'styled-components';

type WeightLabelProps = {
  weight?: number;
  type: LuggageType;
  baggageUnknown: boolean;
  noBaggage: boolean;
  weightUnknown: boolean;
};

const WeightLabel = ({
  weight,
  baggageUnknown,
  noBaggage,
  type,
  weightUnknown,
}: WeightLabelProps) => {
  if (noBaggage || weightUnknown) return null;
  if (baggageUnknown)
    return (
      <StyledLabel $baggageUnknown={baggageUnknown} $type={type}>
        ?
      </StyledLabel>
    );

  return (
    <StyledLabel $baggageUnknown={baggageUnknown} $type={type}>
      {weight}
    </StyledLabel>
  );
};

const StyledLabel = styled.div<{
  $type: LuggageType;
  $baggageUnknown: boolean;
}>`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  color: ${({ $baggageUnknown }) => ($baggageUnknown ? `#919499` : `#45bd81`)};
  line-height: 12px;
  font-size: 8px;
  font-weight: 700;
  ${(props) => {
    switch (props.$type) {
      case 'hand':
        return `padding-top: 6px;`;
      case 'hold':
        return `padding-top: 4px;`;
      case 'ski_equipment':
        return `padding-bottom: 8px;`;
      default:
        return ``;
    }
  }}
`;

export default WeightLabel;
